<template>
  <div class="px-2">
    <v-progress-circular v-if="loading"></v-progress-circular>
    <div v-else>
      <v-dialog v-model="shouldShowVisitAssistPopup" width="500" persistent>
        <v-card>
          <v-card-title>
            <div class="headline">Besoin d'être accompagné(e) ?</div>
          </v-card-title>
          <v-card-text>
            <p>
              Une première visite a été planifiée. Est ce que vous souhaitez
              être accompagné(e) par une personne de nos services lors des
              visites à venir ?
            </p>
          </v-card-text>

          <v-divider />

          <v-card-actions>
            <v-spacer />
            <v-btn
              flat
              :disabled="disableAnswerBtn"
              @click="answerVisitAssist(false)"
              >Non</v-btn
            >
            <v-btn
              flat
              :disabled="disableAnswerBtn"
              @click="answerVisitAssist(true)"
              >Oui</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="shouldShowFeedbackPopup" width="500" persistent>
        <v-card>
          <v-card-title>
            <div class="headline">Votre avis nous intéresse !</div>
          </v-card-title>
          <v-card-text>
            <p>
              Vous a-t-on bien expliqué le service avant de démarrer la mission
              ?
            </p>
            <v-rating v-model="ratings.preparation" />
            <p class="pt-2">
              Vous a-t-on bien accompagné jusqu'à vous trouver votre logement ?
            </p>
            <v-rating v-model="ratings.handling" />

            <v-divider class="py-2" />

            <p>
              Votre avis est important, laissez-nous votre commentaire et
              partagez votre expérience sur Google en cliquant sur le lien
              suivant:
              <a href="https://g.page/r/Ceb9avzlH2ghEB0/review" target="_blank"
                >https://g.page/r/Ceb9avzlH2ghEB0/review</a
              >
            </p>
            <v-textarea v-model="ratings.comment" label="Commentaire:" />

            <v-divider />

            <p class="pt-1 caption text--disabled" style="text-align: justify">
              Les données recueillies via cette enquête sont traitées sur la
              base de votre consentement. Vos réponses sont facultatives et le
              défaut de réponse est sans conséquence. Vos réponses seront
              transmises aux seules personnes habilitées, lesquelles sont
              soumises au devoir de confidentialité. Conformément à la loi
              applicable, vous disposez de différents droits pour maitriser vos
              données que vous pouvez exercer en vous adressant à
              <a @click="openDPOMailTo">DPO@homeinlove.fr</a>.
            </p>
          </v-card-text>

          <v-divider />

          <v-card-actions>
            <v-spacer />
            <v-btn flat @click="cancelFeedback">Ignorer</v-btn>
            <v-btn
              color="primary"
              flat
              :disabled="disableFeedbackPopupSend"
              @click="sendFeedback"
            >
              Envoyer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-card
        class="my-2 px-2 py-2 font-weight-bold d-flex d-flex-initial align-center"
        style="background: #ff7c5d; color: white"
        v-if="status === 'projectCreated'"
      >
        <v-icon color="white" class="mr-2">access_time</v-icon>
        <div>
          Merci pour votre inscription. nous vous recontacterons rapidement pour
          échanger sur votre projet et démarrer l'accompagnement. Jusqu'à celà
          vous ne recevrez pas de proposition. En revanche, vous pouvez nous
          contacter à tout moment au +33 7 67 38 23 68.
        </div>
      </v-card>
      <v-card
        class="my-2 px-2 py-2 font-weight-bold d-flex d-flex-initial align-center"
        style="background: green; color: white"
        v-if="endStatus"
      >
        <v-icon color="white" class="mr-2">check</v-icon>
        <div>Votre dossier est terminé !</div>
      </v-card>
      <v-card class="mt-3 px-2 py-2" v-if="missingReports.length > 0">
        <h2 class="mb-3">Comptes-rendus à saisir</h2>
        <v-list subheader>
          <v-list-tile
            v-for="visit in missingReports"
            :to="proposalUrl(visit)"
            :key="visit._id"
            avatar
            @click=""
          >
            <v-list-tile-avatar>
              <img
                :src="
                  visit._host.photoUrlEstate[0]
                    ? `${apiUrl}/v1/cache/image/${
                        visit._host.photoUrlEstate[0]
                      }.png`
                    : defaultImage
                "
              />
            </v-list-tile-avatar>

            <v-list-tile-content>
              <v-list-tile-title
                v-html="visit._host.address"
              ></v-list-tile-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <v-btn icon>
                <v-icon>edit</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-card>
      <div
        v-for="{ folder, files, started } in folders"
        :key="folder.title"
        class="mt-2"
      >
        <v-card
          v-if="started && files.length > 0"
          class="d-flex d-flex-initial py-2 px-2 align-center justify-space-between"
          color="accent"
        >
          <div class="d-flex align-center">
            <v-icon color="white">folder_shared</v-icon>
            <div class="pl-2 font-weight-bold white--text">
              <div class="subheading">{{ folder.title }}</div>
              Il nous manque {{ files.length }} document{{
                files.length > 1 ? "s" : ""
              }}
            </div>
          </div>
          <v-btn
            color="white"
            :to="`/leases/project/${$route.params.lease_id}/documents`"
            >Voir</v-btn
          >
        </v-card>
        <v-card
          v-if="started && files.length === 0"
          class="d-flex d-flex-initial py-2 px-2 align-center justify-space-between"
          color="primary"
        >
          <div class="d-flex align-center">
            <v-icon color="white">check</v-icon>
            <div class="pl-2 font-weight-bold white--text">
              <div class="subheading">{{ folder.title }}</div>
              <span v-if="folder.title === 'Dossier Mobilipass'">
                Les documents du Mobili-pass sont complets. Nous pouvons
                démarrer la mission. A partir de ce moment, vous vous engagez à
                nous remettre tous les documents nécessaires à la mise en place
                de la subvention pour la prise en charge de nos services.
              </span>
              <span v-else> Nous avons tous les documents nécessaires </span>
            </div>
          </div>
        </v-card>
      </div>

      <div v-if="proposals.length > 0">
        <v-card
          v-if="hostsToEvaluate.length > 0"
          class="d-flex d-flex-initial py-2 px-2 align-center justify-space-between mt-3"
          color="accent"
        >
          <div class="d-flex align-center">
            <v-icon color="white">list</v-icon>
            <div class="pl-2 font-weight-bold white--text">
              Vous avez {{ hostsToEvaluate.length }} nouvelle{{
                hostsToEvaluate.length > 1 ? "s" : ""
              }}
              proposition{{ hostsToEvaluate.length > 1 ? "s" : "" }}
            </div>
          </div>
          <v-btn
            color="white"
            :to="`/leases/project/${$route.params.lease_id}/proposals`"
            >Voir</v-btn
          >
        </v-card>
        <v-card
          v-else
          class="d-flex d-flex-initial py-2 px-2 align-center justify-space-between mt-2"
          color="primary"
        >
          <div class="d-flex align-center">
            <v-icon color="white">check</v-icon>
            <div class="pl-2 font-weight-bold white--text">
              Vous avez vu toutes les propositions
            </div>
          </div>
        </v-card>
      </div>

      <v-card class="mt-3 px-2 py-2">
        <h2 class="mb-3">Visites à venir</h2>
        <div class="notice" v-if="plannedVisits.length === 0">
          Aucune visite planifiée
        </div>
        <v-list subheader>
          <v-list-tile
            :to="proposalUrl(visit)"
            v-for="visit in plannedVisits"
            :key="visit._id"
            avatar
            @click=""
          >
            <v-list-tile-avatar>
              <img
                :src="
                  visit._host.photoUrlEstate[0]
                    ? `${apiUrl}/v1/cache/image/${
                        visit._host.photoUrlEstate[0]
                      }.png`
                    : defaultImage
                "
              />
            </v-list-tile-avatar>

            <v-list-tile-content>
              <v-list-tile-title>{{
                visit.visited.dateVisite | fullDate
              }}</v-list-tile-title>
              <v-list-tile-sub-title>
                {{ visit._host.address }}
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-card>
    </div>
  </div>
</template>

<script>
import { API_URL } from "../../../../webapp-commons/config";
import moment from "moment";
const defaultImage = require("../../assets/hil-logo.png");

export default {
  props: ["id"],
  data() {
    return {
      loading: true,
      apiUrl: API_URL,
      disableAnswerBtn: false,
      ratings: {
        comment: null,
        preparation: null,
        handling: null
      }
    };
  },
  async mounted() {
    this.reload();
  },

  computed: {
    defaultImage() {
      return defaultImage;
    },

    documents() {
      return this.$store.state.currentProjectDocuments.filter(
        d => d.type === "file"
      );
    },
    folders() {
      return this.$store.state.currentProjectDocuments
        .filter(d => d.type === "folder")
        .map(folder => ({
          folder,
          files: this.$store.state.currentProjectDocuments.filter(
            ({ type, parentFolder, driveId }) =>
              type === "file" &&
              parentFolder === folder._id &&
              driveId.length === 0
          ),
          started:
            this.$store.state.currentProjectDocuments.filter(
              ({ type, parentFolder }) =>
                type === "file" && parentFolder === folder._id
            ).length > 0
        }));
    },
    missingDocuments() {
      const d = this.$store.state.currentProjectDocuments.filter(
        d => d.driveId.length === 0
      );
      return d;
    },
    proposals() {
      return this.$store.state.currentProjectProposals;
    },
    hostsToEvaluate() {
      return this.$store.state.currentProjectProposals.filter(
        ({ liked, disliked, disabled }) =>
          !disabled && liked == null && disliked == null
      );
    },
    plannedVisits() {
      return this.$store.state.currentProjectProposals.filter(
        ({ visited, disabled }) =>
          !disabled &&
          visited &&
          visited.dateVisite &&
          moment(visited.dateVisite).isAfter(moment())
      );
    },
    missingReports() {
      return this.$store.state.currentProjectProposals.filter(
        ({ visited, disabled }) =>
          !disabled &&
          visited &&
          moment(visited.dateVisite).isBefore(moment()) &&
          visited.report == null
      );
    },
    status() {
      const project = this.$store.state.currentProject;
      return project && project.currentProgress;
    },
    endStatus() {
      if (this.status != null) {
        return (
          ["submittedToHil", "sentToAL", "paid"].indexOf(this.status) !==
          -1
        );
      }
      return false;
    },
    shouldShowVisitAssistPopup() {
      return this.$store.state.currentProject.wantsVisitAssist === null;
    },
    shouldShowFeedbackPopup() {
      return (
        !this.shouldShowVisitAssistPopup &&
        this.status === "leaseFetched" &&
        !this.$store.state.currentProject.feedback
      );
    },
    disableFeedbackPopupSend() {
      return (
        this.ratings.preparation === null || this.ratings.handling === null
      );
    }
  },

  methods: {
    async reload() {
      this.loading = true;
      const projectId = this.id;
      await this.$store.dispatch("fetchDocumentsForProject", {
        id: projectId
      });
      await this.$store.dispatch("fetchProposals", {
        id: projectId
      });
      this.loading = false;
    },
    proposalUrl(prop) {
      return `/leases/project/${this.$route.params.lease_id}/proposals/${
        prop._host._id
      }`;
    },
    async answerVisitAssist(value) {
      this.disableAnswerBtn = true;
      try {
        await this.$store.dispatch("sendVisitAssist", {
          id: this.id,
          answer: value
        });
      } finally {
        this.disableAnswerBtn = false;
      }
    },
    async cancelFeedback() {
      this.disableAnswerBtn = true;
      try {
        await this.$store.dispatch("sendFeedback", {
          id: this.id,
          ratings: { preparation: null, handling: null, comment: null }
        });
      } finally {
        this.disableAnswerBtn = false;
      }
    },
    async sendFeedback() {
      this.disableAnswerBtn = true;
      try {
        await this.$store.dispatch("sendFeedback", {
          id: this.id,
          ratings: this.ratings
        });
      } finally {
        this.disableAnswerBtn = false;
      }
    },
    openDPOMailTo() {
      window.open("mailto:DPO@homeinlove.fr", "_blank");
    }
  },

  watch: {}
};
</script>
